import { types } from 'mobx-state-tree';

const OrderStatusClass = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  CONFIRMED: 'CONFIRMED',
  DEACTIVATED: 'DEACTIVATED',
  ON_HOLD: 'ON_HOLD',
  PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
  PAYMENT_DENIED: 'PAYMENT_DENIED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  READY: 'READY',
  UNFINISHED: 'UNFINISHED'
};

export default OrderStatusClass;

export const OrderStatusType = types.enumeration(
  'OrderStatusClass',
  Object.values(OrderStatusClass)
);
